import { useRouter } from 'next/router'
import { useEffect } from 'react'

import { config } from '@/lib/config'
import { routes } from '@/lib/routes'
import { getNestedVenueSlug } from '@/utils/venue'

import { useCurrentUser } from './useCurrentUser'

export const useLogin = () => {
  const { query, asPath, replace } = useRouter()
  const { currentUser, fetchingCurrentUser } = useCurrentUser()
  const venueSlug = getNestedVenueSlug(query)
  const loginRoute =
    config.environment === 'production' ? routes.login : routes.loginSsr

  useEffect(() => {
    if (!fetchingCurrentUser && !currentUser && venueSlug) {
      void replace(
        loginRoute.href({
          venueSlug,
          returnTo: asPath,
        }),
        loginRoute.toPath!({
          venueSlug,
          returnTo: asPath,
        }),
      )
    }
  }, [fetchingCurrentUser, currentUser, venueSlug, asPath, replace, loginRoute])

  return {
    fetchingCurrentUser,
    currentUser,
  }
}
